module.exports = __webpack_public_path__ + "static/media/logo.f80ee816.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/logo.png
// module id = 409
// module chunks = 0